import { render, staticRenderFns } from "./CartPending.vue?vue&type=template&id=61cc87f4"
import script from "./CartPending.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPending.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports